import { Action, Types } from "./planningConflicts.actions"

export type PlanningConflictState = {
  errors: {}
  loading: boolean
}

const initialState: PlanningConflictState = {
  errors: {},
  loading: false,
}

export default (state = initialState, action: Action): PlanningConflictState => {
  switch (action.type) {
    case Types.PATCH:
      return {
        ...state,
      }

    case Types.PATCH_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
      }

    default:
      return state
  }
}
